<template>
  <CaseListComp></CaseListComp>
</template>
<script>
import CaseListComp from "../../components/Case/CaseList.vue";

export default {
  name: "Cases List",
  components: { CaseListComp },
  computed: {},
  mounted() {},
};
</script>
